// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b0348522","608":"b55a85b0","641":"fb250b5f","756":"a9c0c8db","790":"01e8151e","867":"43a73304"}[chunkId] + ".chunk.js";
};